import { createReducer } from 'typesafe-actions';
import { generateId } from '../../../common/helpers/identifiers';
import { NotificationActions, addNotification, removeNotification } from './actions';
import { NotificationMessage } from './types';

export interface NotificationsState {
    messages: NotificationMessage[];
}

const notificationsReducer = createReducer<NotificationsState, NotificationActions>({ messages: [] })
    .handleAction(addNotification, (state, { payload }) => {
        const messageId = generateId();
        const message: NotificationMessage = { id: messageId, text: payload.message };
        if (payload.autoHideInterval) {
            message.autoHideIntervalSeconds = payload.autoHideInterval;
        }
        if (payload.displayType) {
            message.displayType = payload.displayType;
        }
        if (payload.isSticky !== undefined) {
            message.isSticky = payload.isSticky;
        }
        if (payload.dismissable !== undefined) {
            message.dismissable = payload.dismissable;
        }
        const messages = [...state.messages, message];
        return { messages };
    })
    .handleAction(removeNotification, (state, { payload }) => {
        const messages = state.messages.filter(msg => msg.id !== payload.id);
        return { messages };
    });

export default notificationsReducer;
